import { render } from "./AppPremiseType.vue?vue&type=template&id=093ffecd&scoped=true"
import script from "./AppPremiseType.vue?vue&type=script&lang=js"
export * from "./AppPremiseType.vue?vue&type=script&lang=js"

import "./AppPremiseType.vue?vue&type=style&index=0&id=093ffecd&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093ffecd"]])

export default __exports__